import React, { useState, useEffect } from 'react';
import { crearProducto } from '../api';

const BASE_URL = 'https://api.app.pixventa.com';
const EMOJIS = ['👗','👕','👖','🧥','👜','👠','💄','🧣','👒','💍'];

function ModalProducto({ onCerrar, onGuardado }) {
  const [emoji,            setEmoji]            = useState('👗');
  const [nombre,           setNombre]           = useState('');
  const [descripcion,      setDescripcion]      = useState('');
  const [precio,           setPrecio]           = useState('');
  const [tieneVariantes,   setTieneVariantes]   = useState(false);
  const [cantidad,         setCantidad]         = useState(0);
  const [guardando,        setGuardando]        = useState(false);
  const [grupos,           setGrupos]           = useState([]);
  const [variantes,        setVariantes]        = useState([{ grupoId: null, seleccion: [] }]);
  const [addingOpcion,     setAddingOpcion]     = useState(null);
  const [nuevaOpcionNombre,setNuevaOpcionNombre]= useState('');
  const [nuevaOpcionHex,   setNuevaOpcionHex]   = useState('#ff9a9e');

  useEffect(() => {
    if (tieneVariantes) cargarGrupos();
  }, [tieneVariantes]);

  async function cargarGrupos() {
    const res  = await fetch(`${BASE_URL}/variante-grupos`);
    const data = await res.json();
    setGrupos(data);
  }

  function cambiarGrupo(idx, grupoId) {
    const nuevo = [...variantes];
    nuevo[idx] = { grupoId: grupoId ? parseInt(grupoId) : null, seleccion: [] };
    setVariantes(nuevo);
  }

  function toggleOpcion(varIdx, opcion) {
    const nuevo = [...variantes];
    const sel   = nuevo[varIdx].seleccion;
    const existe = sel.find(o => o.id === opcion.id);
    nuevo[varIdx].seleccion = existe
      ? sel.filter(o => o.id !== opcion.id)
      : [...sel, opcion];
    setVariantes(nuevo);
  }

  function agregarVariante() {
    setVariantes(prev => [...prev, { grupoId: null, seleccion: [] }]);
  }

  function eliminarVariante(idx) {
    setVariantes(prev => prev.filter((_, i) => i !== idx));
  }

  function totalVariantes() {
    const conSel = variantes.filter(v => v.grupoId && v.seleccion.length > 0);
    if (conSel.length === 0) return 0;
    return conSel.reduce((acc, v) => acc * v.seleccion.length, 1);
  }

  async function guardarNuevaOpcion(varIdx, grupo) {
    if (!nuevaOpcionNombre.trim()) return;
    const existe = grupo.opciones.find(o => o.nombre.toLowerCase() === nuevaOpcionNombre.trim().toLowerCase());
    if (existe) { alert(`⚠️ "${nuevaOpcionNombre}" ya existe`); return; }

    const res = await fetch(`${BASE_URL}/variante-opciones`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grupo_id: grupo.id,
        nombre: nuevaOpcionNombre.trim(),
        hex: grupo.tipo === 'color' ? nuevaOpcionHex : null,
      }),
    });
    const nueva = await res.json();

    setGrupos(prev => prev.map(g =>
      g.id === grupo.id ? { ...g, opciones: [...g.opciones, nueva] } : g
    ));

    const nuevoVar = [...variantes];
    nuevoVar[varIdx].seleccion = [...nuevoVar[varIdx].seleccion, nueva];
    setVariantes(nuevoVar);

    setNuevaOpcionNombre('');
    setNuevaOpcionHex('#ff9a9e');
    setAddingOpcion(null);
  }

  async function handleGuardar() {
    if (!nombre || !precio) { alert('Completa nombre y precio'); return; }
    setGuardando(true);

    const precioLimpio = parseFloat(String(precio).replace(/,/g, '')) || 0;
    let combos = [];

    if (!tieneVariantes) {
      combos = [{ talla: 'Única', color: 'Única', color_hex: '#cccccc', stock: cantidad }];
    } else {
      const varConSel = variantes.filter(v => v.grupoId && v.seleccion.length > 0);
      if (varConSel.length === 0) {
        combos = [{ talla: 'Única', color: 'Única', color_hex: '#cccccc', stock: 0 }];
      } else {
        let result = [[]];
        for (const v of varConSel) {
          const nuevas = [];
          for (const combo of result) {
            for (const op of v.seleccion) {
              nuevas.push([...combo, { grupoId: v.grupoId, opcion: op }]);
            }
          }
          result = nuevas;
        }
        combos = result.map(combo => ({
          talla: combo.map(c => c.opcion.nombre).join(' / '),
          color: combo[0]?.opcion.nombre || 'Única',
          color_hex: combo[0]?.opcion.hex || '#cccccc',
          stock: 0,
        }));
      }
    }

    await crearProducto({ emoji, nombre, descripcion, precio: precioLimpio, variantes: combos });
    setGuardando(false);
    onGuardado();
  }

  const gruposUsados = variantes.filter(v => v.grupoId).map(v => v.grupoId);

  return (
    <div style={styles.overlay} onClick={e => {
      if (e.target === e.currentTarget) {
        if (nombre || precio || descripcion) {
          if (window.confirm('¿Seguro que quieres cerrar? Se perderán los datos ingresados.')) {
            onCerrar();
          }
        } else {
          onCerrar();
        }
      }
    }}>
      <div style={styles.modal}>
        <div style={styles.handle} />
        <div style={styles.header}>
          <div style={styles.title}>Nuevo producto</div>
          <button style={styles.closeBtn} onClick={() => {
            if (nombre || precio || descripcion) {
              if (window.confirm('¿Seguro que quieres cerrar? Se perderán los datos ingresados.')) {
                onCerrar();
              }
            } else {
              onCerrar();
            }
          }}>✕</button>
        </div>
        <div style={styles.body}>

          {/* Emoji */}
          <div style={styles.group}>
            <label style={styles.label}>Ícono del producto</label>
            <div style={styles.emojiRow}>
              {EMOJIS.map(e => (
                <button key={e} style={{ ...styles.emojiBtn, background: emoji === e ? '#e8f5e9' : '#f5f5f5', border: emoji === e ? '2px solid #25D366' : '2px solid transparent' }} onClick={() => setEmoji(e)}>{e}</button>
              ))}
            </div>
          </div>

          {/* Nombre */}
          <div style={styles.group}>
            <label style={styles.label}>Nombre del producto</label>
            <input style={styles.input} placeholder="Ej. Vestido Floral Primavera" value={nombre} onChange={e => setNombre(e.target.value)} />
          </div>

          {/* Descripción */}
          <div style={styles.group}>
            <label style={styles.label}>Descripción</label>
            <textarea style={{ ...styles.input, height: 80, resize: 'none' }} placeholder="Describe materiales, cuidados, detalles..." value={descripcion} onChange={e => setDescripcion(e.target.value)} />
          </div>

          {/* Precio */}
          <div style={styles.group}>
            <label style={styles.label}>Precio ($MXN)</label>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#7A8F89', fontSize: 14, pointerEvents: 'none' }}>$</span>
              <input
                style={{ ...styles.input, paddingLeft: 24, boxSizing: 'border-box' }}
                type="text"
                placeholder="380"
                value={precio}
                onChange={e => setPrecio(e.target.value.replace(/[^0-9.]/g, ''))}
                onBlur={e => {
                  const num = parseFloat(e.target.value.replace(/,/g, '')) || 0;
                  setPrecio(num.toLocaleString('es-MX', { minimumFractionDigits: 2 }));
                }}
              />
            </div>
          </div>

          {/* Tipo */}
          <div style={styles.group}>
            <label style={styles.label}>Tipo de producto</label>
            <div style={styles.tipoRow}>
              <button style={{ ...styles.tipoBtn, ...(!tieneVariantes ? styles.tipoBtnSel : {}) }} onClick={() => setTieneVariantes(false)}>
                <div style={styles.tipoIcon}>📦</div>
                <div style={styles.tipoNombre}>Simple</div>
                <div style={styles.tipoDesc}>Sin variantes</div>
              </button>
              <button style={{ ...styles.tipoBtn, ...(tieneVariantes ? styles.tipoBtnSel : {}) }} onClick={() => setTieneVariantes(true)}>
                <div style={styles.tipoIcon}>🎨</div>
                <div style={styles.tipoNombre}>Variable</div>
                <div style={styles.tipoDesc}>Con variantes</div>
              </button>
            </div>
          </div>

          {/* Simple */}
          {!tieneVariantes && (
            <div style={styles.group}>
              <label style={styles.label}>Cantidad en inventario</label>
              <div style={styles.qtyRow}>
                <button style={styles.qtyBtn} onClick={() => setCantidad(c => Math.max(0, c - 1))}>−</button>
                <span style={styles.qtyNum}>{cantidad}</span>
                <button style={styles.qtyBtn} onClick={() => setCantidad(c => c + 1)}>+</button>
              </div>
            </div>
          )}

          {/* Variable */}
          {tieneVariantes && (
            <div style={styles.group}>
              <label style={styles.label}>Variantes del producto</label>

              {variantes.map((v, idx) => {
                const grupo = grupos.find(g => g.id === v.grupoId);
                return (
                  <div key={idx} style={styles.varianteItem}>
                    <div style={styles.varianteHeader}>
                      <div style={styles.varianteNum}>{idx + 1}</div>
                      <select style={styles.varianteSelect} value={v.grupoId || ''} onChange={e => cambiarGrupo(idx, e.target.value)}>
                        <option value="">Selecciona un grupo...</option>
                        {grupos.map(g => (
                          <option key={g.id} value={g.id} disabled={gruposUsados.includes(g.id) && v.grupoId !== g.id}>
                            {g.nombre}{gruposUsados.includes(g.id) && v.grupoId !== g.id ? ' (ya agregado)' : ''}
                          </option>
                        ))}
                      </select>
                      {variantes.length > 1 && (
                        <button style={styles.varianteDel} onClick={() => eliminarVariante(idx)}>🗑</button>
                      )}
                    </div>

                    {grupo && (
                      <div style={styles.varianteOpciones}>
                        <div style={styles.chips}>
                          {grupo.opciones.map(o => {
                            const sel = v.seleccion.find(s => s.id === o.id);
                            return (
                              <button
                                key={o.id}
                                style={{ ...styles.chip, ...(sel ? styles.chipSel : {}), display: 'flex', alignItems: 'center', gap: 6 }}
                                onClick={() => toggleOpcion(idx, o)}
                              >
                                {grupo.tipo === 'color' && (
                                  <span style={{ width: 10, height: 10, borderRadius: '50%', background: o.hex, display: 'inline-block', border: '1px solid rgba(0,0,0,.15)', flexShrink: 0 }} />
                                )}
                                {o.nombre}
                              </button>
                            );
                          })}
                          <button style={styles.addOpcionBtn} onClick={() => setAddingOpcion(addingOpcion === idx ? null : idx)}>＋</button>
                        </div>

                        {addingOpcion === idx && (
                          <div style={styles.addOpcionRow}>
                            {grupo.tipo === 'color' && (
                              <input type="color" style={styles.colorPicker} value={nuevaOpcionHex} onChange={e => setNuevaOpcionHex(e.target.value)} />
                            )}
                            <input
                              style={styles.addOpcionInput}
                              placeholder={grupo.tipo === 'color' ? 'Nombre del color' : 'Nueva opción'}
                              value={nuevaOpcionNombre}
                              onChange={e => setNuevaOpcionNombre(e.target.value)}
                              onKeyDown={e => e.key === 'Enter' && guardarNuevaOpcion(idx, grupo)}
                              autoFocus
                            />
                            <button style={styles.confirmBtn} onClick={() => guardarNuevaOpcion(idx, grupo)}>✓</button>
                            <button style={styles.cancelBtn} onClick={() => { setAddingOpcion(null); setNuevaOpcionNombre(''); }}>✕</button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}

              {gruposUsados.filter(Boolean).length < grupos.length && (
                <button style={styles.addVarianteBtn} onClick={agregarVariante}>
                  <span style={{ fontSize: 18 }}>＋</span> Agregar otra variante
                </button>
              )}

              {totalVariantes() > 0 && (
                <div style={styles.preview}>
                  Se crearán <strong>{totalVariantes()}</strong> variantes
                </div>
              )}
            </div>
          )}

          <button style={{ ...styles.saveBtn, opacity: guardando ? 0.7 : 1 }} onClick={handleGuardar} disabled={guardando}>
            {guardando ? '⏳ Guardando...' : '✓ Guardar producto'}
          </button>

        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay:         { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  modal:           { background: 'white', borderRadius: '24px 24px 0 0', width: '100%', maxWidth: 430, maxHeight: '92vh', overflowY: 'auto' },
  handle:          { width: 40, height: 4, background: '#e0e0e0', borderRadius: 2, margin: '12px auto 0' },
  header:          { padding: '16px 20px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #E4EDE8' },
  title:           { fontSize: 17, fontWeight: 800, color: '#0D1F1A' },
  closeBtn:        { width: 32, height: 32, background: '#F0F4F0', borderRadius: '50%', border: 'none', cursor: 'pointer', fontSize: 16, color: '#7A8F89' },
  body:            { padding: 20 },
  group:           { marginBottom: 16 },
  label:           { display: 'block', fontSize: 12, fontWeight: 700, color: '#7A8F89', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 },
  input:           { width: '100%', background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 12, padding: '12px 14px', fontSize: 14, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' },
  emojiRow:        { display: 'flex', flexWrap: 'wrap', gap: 8 },
  emojiBtn:        { width: 44, height: 44, borderRadius: 12, fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  tipoRow:         { display: 'flex', gap: 10 },
  tipoBtn:         { flex: 1, background: '#F0F4F0', border: '2px solid #E4EDE8', borderRadius: 14, padding: '14px 10px', cursor: 'pointer', textAlign: 'center', transition: 'all .18s', fontFamily: 'inherit' },
  tipoBtnSel:      { background: '#f0fff5', borderColor: '#25D366' },
  tipoIcon:        { fontSize: 28, marginBottom: 6 },
  tipoNombre:      { fontSize: 14, fontWeight: 700, color: '#0D1F1A', marginBottom: 2 },
  tipoDesc:        { fontSize: 11, color: '#7A8F89' },
  qtyRow:          { display: 'flex', alignItems: 'center', gap: 16, background: '#F0F4F0', borderRadius: 12, padding: '10px 14px' },
  qtyBtn:          { width: 32, height: 32, borderRadius: '50%', border: '1.5px solid #E4EDE8', background: 'white', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#128C7E', fontWeight: 700 },
  qtyNum:          { fontSize: 20, fontWeight: 800, color: '#0D1F1A', minWidth: 32, textAlign: 'center' },
  varianteItem:    { border: '1.5px solid #E4EDE8', borderRadius: 14, overflow: 'hidden', marginBottom: 10 },
  varianteHeader:  { display: 'flex', alignItems: 'center', gap: 10, padding: '11px 12px', background: 'linear-gradient(to right,#f0fff5,#f8fcf9)', borderBottom: '1px solid #E4EDE8' },
  varianteNum:     { width: 24, height: 24, background: '#25D366', color: 'white', borderRadius: '50%', fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  varianteSelect:  { flex: 1, background: 'white', border: '1.5px solid #E4EDE8', borderRadius: 10, padding: '7px 10px', fontSize: 13, color: '#0D1F1A', fontFamily: 'inherit', outline: 'none', cursor: 'pointer' },
  varianteDel:     { width: 28, height: 28, background: 'none', border: 'none', color: '#7A8F89', cursor: 'pointer', borderRadius: 8, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  varianteOpciones:{ padding: '10px 12px' },
  chips:           { display: 'flex', flexWrap: 'wrap', gap: 8 },
  chip:            { border: '1.5px solid #E4EDE8', borderRadius: 20, padding: '7px 14px', fontSize: 12, color: '#7A8F89', cursor: 'pointer', background: 'white', fontFamily: 'inherit', fontWeight: 500 },
  chipSel:         { borderColor: '#25D366', background: '#f0fff5', color: '#128C7E', fontWeight: 700 },
  addOpcionBtn:    { border: '1.5px dashed #25D366', borderRadius: 20, padding: '7px 12px', fontSize: 14, color: '#128C7E', cursor: 'pointer', background: 'none', fontFamily: 'inherit', fontWeight: 700 },
  addOpcionRow:    { display: 'flex', alignItems: 'center', gap: 6, marginTop: 10 },
  addOpcionInput:  { flex: 1, background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 10, padding: '7px 12px', fontSize: 13, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit' },
  colorPicker:     { width: 34, height: 34, borderRadius: 8, border: '1.5px solid #E4EDE8', cursor: 'pointer', padding: 2, flexShrink: 0 },
  confirmBtn:      { width: 32, height: 32, background: '#25D366', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, fontWeight: 700, flexShrink: 0 },
  cancelBtn:       { width: 32, height: 32, background: '#F0F4F0', color: '#7A8F89', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, flexShrink: 0 },
  addVarianteBtn:  { width: '100%', background: 'none', border: '2px dashed #E4EDE8', borderRadius: 14, padding: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, color: '#128C7E', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginBottom: 10 },
  preview:         { background: '#f0fff5', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: '#128C7E', fontWeight: 600 },
  saveBtn:         { width: '100%', background: 'linear-gradient(135deg,#25D366,#128C7E)', color: 'white', border: 'none', borderRadius: 16, padding: 16, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8 },
};

export default ModalProducto;